export const getGenericDocumentsByIds = {
    route: '/document/:documentIds',
    method: 'GET',
    source: 'app',
};
